export const phases = [
  { id: 1, name: "Cimentación" },
  { id: 2, name: "Estructura" },
  { id: 3, name: "Albañilería" },
  { id: 4, name: "Instalaciones" },
  { id: 5, name: "Acabados" },
  { id: 6, name: "Finalizado" },
];

export const types = [
  { id: 1, name: "Residencial" },
  { id: 2, name: "Comercial" },
  { id: 3, name: "Industrial" },
  { id: 4, name: "Infraestructura" },
];
